import React from 'react';
import { Box, Button, ButtonSize } from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import config from '@epi-config';

export const AddBeneficiaries = ({
  handleAddEmployees,
  handleImportEmployees
}: {
  handleAddEmployees: () => void;
  handleImportEmployees: () => void;
}) => {
  const { t } = useTranslation();
  const {
    sizeExtraExtraLarge,
    fontSemiBold,
    sizeMedium,
    lightBlue5,
    lightBlue10
  } = useTheme();
  const { enableMassUpload } = config;

  return (
    <Box display="flex" justifyContent="center" alignItems="center" pt={4}>
      <Box display="flex" flexDirection="column" alignItems="center">
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          width={616}
        >
          <Box
            fontSize={sizeExtraExtraLarge}
            fontWeight={fontSemiBold}
            textAlign="center"
          >
            {t('employees.add_employees_title')}
          </Box>
          <Box pt={1} fontSize={sizeMedium} textAlign="center">
            {t('employees.add_employees_description')}
          </Box>
        </Box>
        <Box display="flex" gap={3} pt={5}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            py={3}
            px={4}
            bgcolor={lightBlue5}
            border={`1px solid ${lightBlue10}`}
            width={360}
            justifyContent="space-between"
          >
            <Box textAlign="center">
              <Box fontSize={sizeMedium} fontWeight={fontSemiBold}>
                {t('employees.manual_add_heading')}
              </Box>
              <Box pt={1} textAlign="center">
                {t('employees.manual_add_description')}
              </Box>
            </Box>
            <Box pt={3}>
              <Button
                id="add-employees-btn"
                minWidth={140}
                size={ButtonSize.Medium}
                onClick={handleAddEmployees}
              >
                {t('employees.manual_add_btn')}
              </Button>
            </Box>
          </Box>

          {enableMassUpload && (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              py={3}
              px={4}
              bgcolor={lightBlue5}
              border={`1px solid ${lightBlue10}`}
              width={360}
              justifyContent="space-between"
            >
              <Box textAlign="center">
                <Box fontSize={sizeMedium} fontWeight={fontSemiBold}>
                  {t('employees.import_heading')}
                </Box>
                <Box pt={1} textAlign="center">
                  {t('employees.import_description')}
                </Box>
              </Box>
              <Box pt={3}>
                <Button
                  id="import-employees-btn"
                  minWidth={140}
                  size={ButtonSize.Medium}
                  onClick={handleImportEmployees}
                >
                  {t('employees.import_btn')}
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};
